import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.dev';
import { UsernomalDTO } from '../model/UsernomalDTO';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  // Cambiar el endpoint base a la nueva estructura
  endpoint = `${environment.apiURL}/user`;

  constructor(private http: HttpClient) {}

  // Método para obtener todos los usuarios
  getAllUsers(): Observable<UsernomalDTO[]> {
    return this.http.get<UsernomalDTO[]>(`${this.endpoint}/all`, { withCredentials: true });
  }

  // Método para obtener un usuario por ID
  getUserById(id: string): Observable<UsernomalDTO> {
    return this.http.get<UsernomalDTO>(`${this.endpoint}/${id}`, { withCredentials: true });
  }

  // Método para obtener un usuario por nombre de usuario
  getUserByUsername(username: string): Observable<UsernomalDTO> {
    return this.http.get<UsernomalDTO>(`${this.endpoint}/username/${username}`, { withCredentials: true });
  }

  updateUser(id: string, user: UsernomalDTO): Observable<UsernomalDTO> {
      return this.http.patch<UsernomalDTO>(`${this.endpoint}/update/${id}`, user, { withCredentials: true });
    }
  
}
